export const enum Placeholder {
  Value = '<<\u200bCURRIABLE PLACEHOLDER\u200b>>',
}

export const __ = Placeholder.Value;
